import { Pie } from '@ant-design/plots';
import { Col, Row } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import "./reponse.css";

const RadioType = ({ answers, onReady }) => {
   const chartContainerRef = useRef(null);
  const [data, setData] = useState([]);
  // console.log(answers);

useEffect(() => {
  if (!Array.isArray(answers)) return;

  const counts = {};

  answers.forEach(({ value }) => {
    let parsedValues = [];

 
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        parsedValues = parsed;
      } else {
        parsedValues = [parsed];
      }
    } catch (error) {
      
      parsedValues = [value];
    }

    parsedValues.forEach((val) => {
      counts[val] = (counts[val] || 0) + 1;
    });
  });

  const total = Object.values(counts).reduce((sum, val) => sum + val, 0);

  const formatted = Object.entries(counts).map(([option, value]) => ({
    option,
    value,
    percent: ((value / total) * 100).toFixed(1),
  }));

  setData(formatted);
}, [answers]);

  const config = {
    data,
    angleField: 'value',
    colorField: 'option',
   
    label: {
      text: (datum) => `${datum.percent}%`,
      style: {
        fontWeight: 'bold',
        fill: '#000',
      },
    },
    legend: {
      color: {
        title: false,
        position: 'right',
        rowPadding: 1,
      },
      // style: {
      //    marginBottom:-30,
      // }
    },
  };

  return (
    <div style={{ width: "100%" }} ref={chartContainerRef}>
      <Row justify="center">
        <Col span={10} className="stylPieChart">
           {data.length > 0 && <Pie {...config} onReady={(plot) => {
  if (onReady) onReady(plot);
}} />}
        </Col>
      </Row>
    </div>
  );
};

export default RadioType;
